// extracted by mini-css-extract-plugin
module.exports = {"PageLoader":"PageLoader_PageLoader__1GP9n"};